import { Buffer } from 'buffer'
import crypto from 'crypto-js'

export const generateTraceparent = () => {
  const version = Buffer.alloc(1).toString('hex')
  const traceId = crypto.lib.WordArray.random(16).toString(crypto.enc.Hex)
  const id = crypto.lib.WordArray.random(8).toString(crypto.enc.Hex)
  const flags = '01'

  return `${version}-${traceId}-${id}-${flags}`
}
